module.exports = __webpack_public_path__ + "img/download-on-the-app-store-it.0a6a96b9.svg";